import React from 'react';
import { Box, Grid, Typography, Card, Stack, Skeleton } from '@mui/material';
import { Icon } from '@iconify/react';

const data = {
  pending_count: 13,
  approved_count: 7,
  rejected_count: 2,
  hold_count: 3,
  total_count: 22,
};

const RequestStats = ({ requestStats = data, loading }) => {
  const stats = [
    {
      title: 'Total Requests',
      count: requestStats?.total_count,
      icon: 'mdi:clipboard-list-outline',
      gradient: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
    },
    {
      title: 'Approved Requests',
      count: requestStats?.approved_count,
      icon: 'mdi:check-circle-outline',
      gradient: 'linear-gradient(135deg, #00b09b 0%, #96c93d 100%)',
    },
    {
      title: 'Pending Requests',
      count: requestStats?.pending_count,
      icon: 'mdi:clock-outline',
      gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
    },
    {
      title: 'Hold Requests',
      count: requestStats?.hold_count,
      icon: 'mdi:close-circle-outline',
      gradient: 'linear-gradient(135deg, #ff6600ff 0%, #e9a05bff 100%)',
    },
    {
      title: 'Rejected Requests',
      count: requestStats?.rejected_count,
      icon: 'mdi:close-circle-outline',
      gradient: 'linear-gradient(135deg, #ff512f 0%, #dd2476 100%)',
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, p: 1 }}>
      <Grid container spacing={3}>
        {loading
          ? Array.from({ length: 5 }).map((_, i) => (
              <Grid item xs={12} sm={6} md={2.4} key={i}>
                <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />
              </Grid>
            ))
          : stats.map((item, index) => (
              <Grid item xs={12} sm={6} md={2.4} key={index}>
                <Card
                  sx={{
                    background: item.gradient,
                    color: '#fff',
                    p: 3,
                    borderRadius: 3,
                    boxShadow: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: 120,
                  }}
                >
                  <Stack spacing={1}>
                    <Typography variant="subtitle2">{item.title}</Typography>
                    <Typography variant="h4" sx={{ fontWeight: 600 }}>
                      {item.count}
                    </Typography>
                  </Stack>
                  <Icon icon={item.icon} width="40" height="40" />
                </Card>
              </Grid>
            ))}
      </Grid>
    </Box>
  );
};

export default RequestStats;
